import React from "react";

import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";
import { isGamesTheme } from "@utils";
import { observer } from "mobx-react";

export default observer(function LiveSessionExpirePopupTemplate() {
	const { t } = useTranslation();

	const rootStore = useRootAppStore();

	useFixBody(true);

	return (
		<div className="popup">
			<div className="popup__card popup__card--med">
				<div className="popup__header">
					{t<string>(
						"SESSION.LIVE_SESSION_EXPIRE.LIVE_SESSION_EXPIRED_LABEL"
					)}
				</div>
				<div className="popup__body">
					<i className="u-icon u-icon--huge u-icon--empty u-icon--empty--session u-display--b u-align--h--center u-mar--bottom--xsml"></i>
					<div>
						{t<string>(
							isGamesTheme()
								? "SESSION.LIVE_SESSION_EXPIRE.LIVE_SESSION_EXPIRED_MESSAGE_GAMES"
								: "SESSION.LIVE_SESSION_EXPIRE.LIVE_SESSION_EXPIRED_MESSAGE"
						)}
					</div>
				</div>
				<div className="popup__footer">
					<button
						className="popup__btn btn btn--med btn--accent btn--icon btn--animate-rotate"
						onClick={() => {
							rootStore.offerHub.restartSession();
							rootStore.cashoutHubStore.restartSession();
							rootStore.sportStatisticsHub.restartSession();
							rootStore.betBoosterHubStore.restartSession();
							rootStore.userHubStore.restartSession();
							rootStore.homeStoreManager.refreshStores();
						}}
						type="button"
					>
						<i className="u-icon u-icon--sml u-icon--refresh u-color--accent--text" />
						{t<string>(
							"SESSION.LIVE_SESSION_EXPIRE.BUTTON_REFRESH"
						)}
					</button>
				</div>
			</div>
		</div>
	);
});
